// EthicStone marquise px, scaled 1.73 so 4.0 ct matches their stone-to-hand ratio on BB's hand photo.
const BB_CARAT_SIZES = {
  marquise: {
    desktop: {
      '1.0': 92.54,
      '1.5': 100.17,
      '2.0': 107.93,
      '2.5': 115.56,
      '3.0': 123.33,
      '3.5': 130.96,
      '4.0': 138.73,
      '4.5': 148.26,
      '5.0': 156.03,
      '6.0': 171.9,
      '7.0': 187.78,
      '8.0': 203.65,
      '9.0': 219.52,
      '10.0': 235.4,
    },
    tablet: {
      '1.0': 122.1,
      '1.5': 131.46,
      '2.0': 139.25,
      '2.5': 148.61,
      '3.0': 159.83,
      '3.5': 172.65,
      '4.0': 185.61,
      '4.5': 200.16,
      '5.0': 207.93,
      '6.0': 229.39,
      '7.0': 250.85,
      '8.0': 272.3,
      '9.0': 293.76,
      '10.0': 315.22,
    },
    mobile: {
      '1.0': 71.85,
      '1.5': 78.94,
      '2.0': 86.19,
      '2.5': 93.28,
      '3.0': 100.53,
      '3.5': 107.71,
      '4.0': 114.87,
      '4.5': 122.05,
      '5.0': 129.21,
      '6.0': 143.55,
      '7.0': 157.89,
      '8.0': 172.23,
      '9.0': 186.57,
      '10.0': 200.91,
    },
  },
};

if (!customElements.get('bb-diamond-size-guide')) {
  class BbDiamondSizeGuide extends HTMLElement {
    connectedCallback() {
      this.diamond = this.querySelector('[data-bb-dsg-diamond]');
      this.pills = Array.from(this.querySelectorAll('[data-bb-dsg-pill]'));
      this.bar = this.querySelector('.bb-dsg__pills');
      this.shownWith = this.querySelector('[data-bb-dsg-value]');
      this.shape = (this.dataset.shape || 'marquise').toLowerCase();
      if (this.bar) {
        ['pointerdown', 'touchstart', 'wheel'].forEach((type) => {
          this.bar.addEventListener(type, (event) => event.stopPropagation());
        });
      }
      this.pills.forEach((pill) => {
        pill.addEventListener('pointerdown', (event) => event.stopPropagation());
        pill.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.select(pill.dataset.carat);
        });
      });
      this.select(this.dataset.defaultCarat || '3.0', false);
      this.confirmShapeImage();
    }

    confirmShapeImage() {
      const slide = this.closest('[data-bb-dsg-slide]');
      const gallery = this.closest('media-gallery');
      const src = this.diamond && this.diamond.getAttribute('src');
      const finish = (ok) => {
        const thumb = gallery && gallery.querySelector('[data-bb-dsg-thumb]');
        if (!ok) {
          if (slide) slide.remove();
          if (thumb) thumb.remove();
        } else {
          if (slide) slide.hidden = false;
          if (thumb) thumb.hidden = false;
        }
        const slider = gallery && gallery.sliderInstance && gallery.sliderInstance.slider;
        const thumbs = gallery && gallery.thumbsInstance && gallery.thumbsInstance.slider;
        if (slider) slider.update();
        if (thumbs) thumbs.update();
      };
      if (!src) {
        finish(false);
        return;
      }
      const probe = new Image();
      probe.onload = () => finish(probe.naturalWidth > 0);
      probe.onerror = () => finish(false);
      probe.src = src;
    }

    select(carat, animate = true, broadcast = true) {
      const table = BB_CARAT_SIZES[this.shape] || BB_CARAT_SIZES.marquise;
      if (!this.diamond || !table || !table.desktop[carat]) return;

      const desktop = table.desktop[carat];
      const tablet = table.tablet[carat] || desktop;
      const mobile = table.mobile[carat] || table.mobile['3.0'] || desktop;

      this.diamond.style.transition = animate ? 'width 0.25s ease, height 0.25s ease' : 'none';
      this.diamond.style.setProperty('--bb-dsg-diamond-width', `${desktop.toFixed(2)}px`);
      this.diamond.style.setProperty('--bb-dsg-diamond-height', `${desktop.toFixed(2)}px`);
      this.diamond.style.setProperty('--bb-dsg-diamond-tablet-width', `${tablet.toFixed(2)}px`);
      this.diamond.style.setProperty('--bb-dsg-diamond-tablet-height', `${tablet.toFixed(2)}px`);
      this.diamond.style.setProperty('--bb-dsg-diamond-mobile-width', `${mobile.toFixed(2)}px`);
      this.diamond.style.setProperty('--bb-dsg-diamond-mobile-height', `${mobile.toFixed(2)}px`);

      const selectedPill = this.pills.find((pill) => pill.dataset.carat === carat);
      if (this.shownWith) this.shownWith.textContent = selectedPill?.dataset.label || carat;

      this.pills.forEach((pill) => {
        const selected = pill.dataset.carat === carat;
        pill.classList.toggle('is-selected', selected);
        pill.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (!broadcast) return;
      document.querySelectorAll('bb-diamond-size-guide').forEach((guide) => {
        if (guide !== this) guide.select(carat, animate, false);
      });
    }
  }

  customElements.define('bb-diamond-size-guide', BbDiamondSizeGuide);
}
